import {
  CheckCircle2,
  CircleAlert,
  GitBranch,
  LoaderCircle,
  MailCheck,
} from 'lucide-react'
import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { verifyEmail } from '../api.js'
import { useLanguage } from '../contexts/LanguageContext.jsx'
import { NOINDEX_ROBOTS, setPageMetadata } from '../page-metadata.js'

const verificationRequests = new Map()

function verifyOnce(token) {
  if (!verificationRequests.has(token)) {
    const request = verifyEmail(token).catch((error) => {
      verificationRequests.delete(token)
      throw error
    })
    verificationRequests.set(token, request)
  }
  return verificationRequests.get(token)
}

function VerifyEmailPage() {
  const { t } = useLanguage()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') || ''
  const [status, setStatus] = useState(token ? 'loading' : 'error')
  const [message, setMessage] = useState(
    token ? '正在验证邮箱...' : '验证链接缺少 token，请重新打开邮件中的链接。',
  )

  useEffect(() => setPageMetadata({
    title: '邮箱验证 - 青途 AI',
    description: '青途 AI 账号邮箱验证。',
    robots: NOINDEX_ROBOTS,
  }), [])

  useEffect(() => {
    if (!token) return undefined
    let active = true

    verifyOnce(token)
      .then((data) => {
        if (!active) return
        setStatus('success')
        setMessage(data.message || '邮箱验证成功，现在可以登录。')
      })
      .catch((error) => {
        if (!active) return
        setStatus('error')
        setMessage(error.message || '验证链接无效、已过期或已使用。')
      })

    return () => {
      active = false
    }
  }, [token])

  const icon = status === 'loading'
    ? <LoaderCircle className="spin" size={30} />
    : status === 'success'
      ? <CheckCircle2 size={30} />
      : <CircleAlert size={30} />

  return (
    <main className="auth-action-screen">
      <section className={`auth-action-panel is-${status}`}>
        <Link to="/" className="auth-brand auth-action-brand">
          <span className="brand-icon"><GitBranch size={22} /></span>
          <span>
            <strong>{t('nav.brand')}</strong>
            <small>{t('nav.brandSub')}</small>
          </span>
        </Link>
        <span className="auth-action-icon">{icon}</span>
        <span className="eyebrow"><MailCheck size={14} /> EMAIL VERIFICATION</span>
        <h1>{status === 'success' ? '邮箱验证成功' : '验证邮箱'}</h1>
        <p>{message}</p>
        {status !== 'loading' && (
          <Link className="primary-button auth-action-button" to="/login">
            {status === 'success' ? '去登录' : '返回登录'}
          </Link>
        )}
        <Link className="auth-action-home" to="/">返回首页</Link>
      </section>
    </main>
  )
}

export default VerifyEmailPage
